import { Component, OnChanges, SimpleChanges } from '@angular/core';
import { CpqConfiguratorComponent } from '../cpq-configurator/cpq-configurator.component';
import { first } from 'rxjs';
import {
  CpqPrice,
  ProductConfigurationPriceTotalService
} from '../../../services/cpq/product-configuration-price-total.service';
import { ActivatedRoute } from '@angular/router';
import { ProductService } from '../../../services/products/product.service';
import { ProductConfigurationService } from '../../../services/cpq/product-configuration.service';
import { ProductConfigurationRuleExecutionService } from '../../../services/cpq/product-configuration-rule-execution.service';
import { CartService } from '../../../services/cart/cart.service';
import { GungNotificationService } from 'gung-common';
import { ProductConfigurationFeature, ProductConfigurationOption } from '../../../models/product-configuration-types';

@Component({
  selector: 'lib-cpq-configurator-inline',
  standalone: false,
  templateUrl: './cpq-configurator-inline.component.html',
  styleUrl: './cpq-configurator-inline.component.scss'
})
export class CpqConfiguratorInlineComponent extends CpqConfiguratorComponent implements OnChanges {
  totalPrice = 0;
  currency: string = '';

  constructor(
    protected route: ActivatedRoute,
    protected productService: ProductService,
    protected productConfigurationService: ProductConfigurationService,
    protected ruleExecutionService: ProductConfigurationRuleExecutionService,
    protected cartService: CartService,
    protected gungNotificationService: GungNotificationService,
    protected productConfigurationPriceTotalService: ProductConfigurationPriceTotalService
  ) {
    super(
      route,
      productService,
      productConfigurationService,
      ruleExecutionService,
      cartService,
      gungNotificationService
    );
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!this.configuration) {
      return;
    }

    this.productConfigurationPriceTotalService
      .getConfigurationTotalPrice(this.configuration, this.buildSelection())
      .pipe(first())
      .subscribe((price: CpqPrice) => {
        this.currency = price.currency;
        this.totalPrice = price.totalPrice;
      });
  }

  featureOptionSelected(feature: ProductConfigurationFeature, option: ProductConfigurationOption) {
    super.featureOptionSelected(feature, option);
    this.ngOnChanges({});
  }
}
